import moment, { type Moment } from "moment";

export const SUGGESTED_BID_DEADLINE_DAYS = 35;

// The bid deadline is an absolute instant anchored to "today", so we measure the suggestion when
// the buyer opens the planner — never at draft creation, which would freeze a stale "today" that
// can fall below the moving statutory minimum before publish. 23:59 matches the picker's
// END_OF_DAY default and the browser-zone read-back convention.
export const suggestedBidDeadlineIso = (now: Moment = moment()): string =>
  now
    .clone()
    .add(SUGGESTED_BID_DEADLINE_DAYS, "days")
    .set({ hour: 23, minute: 59, second: 0, millisecond: 0 })
    .toISOString();
